import { render } from "./Develop_strategies_so.vue?vue&type=template&id=3603d5ba&scoped=true"
import script from "./Develop_strategies_so.vue?vue&type=script&lang=js"
export * from "./Develop_strategies_so.vue?vue&type=script&lang=js"

import "./Develop_strategies_so.vue?vue&type=style&index=0&id=3603d5ba&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3603d5ba"]])

export default __exports__